import { TrashIcon } from '@heroicons/react/24/outline';
import React from 'react';

import { DiscriminatedTaskDeletedEvent } from '@/services/api/generated/matterChangesService';

import {
  ActivityBody,
  ActivityIcon,
  ActivityItem,
  ActivityTitle,
} from '../activity-feed-v2';
import { getUserFromEvent } from '../activity-feed-v2/ActivityDiffList';

export interface TaskDeletedEventProps {
  event: DiscriminatedTaskDeletedEvent;
}

export const TaskDeletedEvent: React.FC<TaskDeletedEventProps> = ({
  event,
}) => {
  const { task } = event.payload;
  const user = getUserFromEvent(event);

  const icon = (
    <ActivityIcon
      icon={
        <div className="flex h-6 w-6 items-center justify-center rounded-full bg-red-100">
          <TrashIcon className="h-4 w-4 text-red-600" />
        </div>
      }
    />
  );

  const body = (
    <ActivityBody>
      {task?.name && <ActivityTitle>{task.name}</ActivityTitle>}
    </ActivityBody>
  );

  return (
    <ActivityItem
      icon={icon}
      title="Task Deleted"
      timestamp={new Date(event.occurred_at ?? new Date())}
      user={user}
      body={body}
    />
  );
};
